import React from 'react';
import PropTypes from 'prop-types';
import AccountDataPointPanel from './AccountDataPointPanel';
import { formatNumberWhole } from '../../../../shared/components/table/functions';

export default function Impressions({
  data, loading, dateView, title, subtitle,
}) {
  return (
    <AccountDataPointPanel
      data={data}
      title={title}
      subtitle={subtitle}
      dayField="impressions"
      formatFunction={item => formatNumberWhole(item)}
      barColor="#ffb153"
      loading={loading}
      dateView={dateView}
    />
  );
}

Impressions.defaultProps = {
  data: null,
  title: 'Impressions',
  subtitle: 'Total for Date Range',
};

Impressions.propTypes = {
  loading: PropTypes.bool.isRequired,
  dateView: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Array),
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
